import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import OnJob from './staff-template';
import _downTemplates, { all } from './staff-template/slot/tem-map';
export default {
  props: {
    content: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    staffData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    OnJob: OnJob
  },
  computed: {
    // 模版列表
    downTemplates: function downTemplates() {
      var _this = this;
      var data = all;
      var sendLanguage = this.staffData.send_language;
      if (this.staffData.send_language) {
        var keys = Object.keys(_downTemplates);
        if (sendLanguage.length === keys.length) {
          data = all;
        } else {
          keys.forEach(function (item) {
            if (_this.staffData.send_language.includes(item)) data = _downTemplates[item];
          });
        }
      }
      return data;
    },
    currentTem: function currentTem() {
      return this.downTemplates.get(this.activeName);
    }
  },
  data: function data() {
    return {
      visible: false,
      activeName: '1'
    };
  }
};